import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/nrs-portal/nrs-portal/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/nrs-portal/nrs-portal/node_modules/@mui/material/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/nrs-portal/nrs-portal/node_modules/@mui/material/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/nrs-portal/nrs-portal/node_modules/@mui/material/Divider/Divider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/nrs-portal/nrs-portal/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/nrs-portal/nrs-portal/node_modules/next/dist/client/app-dir/link.js");
